var scope_0 = require('/vercel/2a2ba5ce/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/vercel/2a2ba5ce/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a85a85be43e040e579016980fc0b869b.js').default;
var scope_2 = require('/vercel/2a2ba5ce/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b58681af65f9adc03176f72c24375ef6.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    